import { ReactNode } from 'react'
import { Location, Navigate } from 'react-router-dom'

import { RouteNames } from '@/routes'
import { LoadingRoute } from '@/routes/LoadingRoute'
import { useStoreState } from '@/store/hooks'

export function AuthChecker({ children, location }: { children: ReactNode; location: Location }) {
  const { isWaitingForAuthentication, isAuthenticated } = useStoreState((state) => state.auth)
  if (isWaitingForAuthentication) return <LoadingRoute />
  if (isAuthenticated) return <>{children}</>
  return (
    <Navigate
      to={RouteNames.Root + RouteNames.Login}
      replace={true}
      state={{ from: location }} // Pass the original location for redirection after login
    />
  )
}
